



import Component, { mixins } from "vue-class-component";
import MakeDepositComponent from "@/views/bank/deposits/MakeDeposit.vue";
import { RouterUtils } from "@/router/RouterUtils";

@Component({
  components: {
    MakeDepositComponent
  }
})
export default class BankDeposits extends mixins(RouterUtils) {
  handleNext() {
    this.goBankPage();
  }
}
